<template>
	<el-row style="width: 100%;" :gutter="2">
		<el-col :span="4" style="text-align: left;">
			<el-select v-model="countryCode" @change="onPhoneCodeChange">
				<template #label="e">
					<span>{{ e.label }} {{ e.value }}</span>
				</template>
				<el-option
					v-for="e in countryCodes"
					:key="e.code"
					:label="e.label"
					:value="e.code">
					{{ e.label }}&nbsp;{{ e.code }}
				</el-option>
			</el-select>
		</el-col>	
		<el-col :span="1"></el-col>
		<el-col :span="12">
			<el-input
				v-model="phone" 
				:maxlength="12"
				:minlength="10"
			/>
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import EmployeeModel from '@/models/EmployeeModel';
import EmployeesApiHelper from '@/helpers/api/EmployeesApiHelper';
import store from '@/store';
import { WatchStopHandle, watch } from 'vue';

@Options({	
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: String,
			default: ''
		}
	},
	emits: ['update:modelValue'],
})
export default class InputPhoneComponent extends Vue {
	/** props */
	disabled!: boolean;
	managers!: Array<EmployeeModel>;
	loadManagers!: boolean;
	allowEmptyManager!: boolean;
	modelValue!: string;

	/** constants */
	phoneNumberRegex = /^(\+[0-9]{1,5})([7-9][0-9]{9})$/;
	countryCodes = [
		{code: '+994', label:'🇦🇿'},
		{code: '+374', label:'🇦🇲'},
		{code: '+7', label:'🇷🇺', default: true},
		{code: '+90', label:'🇹🇷'}
	];

	/** view-models */
	countryCode: string | null = null;
	phone: string | null = null;

	phoneWathSubscription?: WatchStopHandle;

	mounted() {
		if (this.modelValue) {
			const inputNumber = this.modelValue.startsWith('+') ? this.modelValue : `+${this.modelValue}`;
			const matches = this.phoneNumberRegex.exec(inputNumber)!;
			if (matches?.length != 3) {
				this.countryCode = this.countryCodes.find(_ => _.default)!.code;
				this.phone = inputNumber;
			} else {
				const countryCode = matches[1];
				const phoneCode = matches[2];
				this.countryCode = countryCode;
				this.phone = phoneCode;
			}
		} else {
			this.countryCode = this.countryCodes.find(_ => _.default)!.code;
		}

		this.phoneWathSubscription = watch(
			() => this.phone,
			() => this.$emit('update:modelValue', this.formatQualifiedPhoneNumber())
		)
	}

	unmounted() {
		if (this.phoneWathSubscription) {
			this.phoneWathSubscription();
		}
	}

	async fetchManagersAsync() {
		if (this.allowEmptyManager) {
			this.managers = [
				new EmployeeModel({id: 0})
			];
		}
		const existingManagers = await new EmployeesApiHelper().getManagersAsync(store.getters.jwt);
		existingManagers.forEach(m =>
			this.managers.push(m)
		);
		this.managers = existingManagers;
	}

	onSelectManagerChanged() {
		this.$emit('update:modelValue', 'this.selectedManagerId');
	}

	formatQualifiedPhoneNumber() {
		return `${this.countryCode}${this.phone}`;
	}

	onPhoneCodeChange() {
		this.$emit('update:modelValue', this.formatQualifiedPhoneNumber());
	}
}
</script>